
import { Component, Vue, Prop } from "vue-property-decorator";

import CUpload from "@/components/Upload.vue";
import CImageView from "@/components/ImageView.vue";

import UnitVersion from "@/models/unit/unit_version";
import TestVersion from "@/models/unit/unitable/test/version";
import TestQuestionVersion from "@/models/unit/unitable/test/question_version";
import { questionTypes } from "@/models/unit/unitable/test/question";
import TestAnswerVersion from "@/models/unit/unitable/test/answer_version";

@Component({
  name: "CTestingsChangeQuestions",
  components: {
    CUpload,
    CImageView
  }
})
export default class CTestingsChangeQuestions extends Vue {
  @Prop({ required: true }) public testing!: UnitVersion;
  @Prop({ required: false, default: false }) public disabled!: boolean;

  public question_types = questionTypes;

  public use_image_options = [
    { label: "Использовать", value: true },
    { label: "Не использовать", value: false }
  ];

  public accepted_image_types: string[] = ["image/png", "image/jpeg"];

  public unitable() {
    return this.testing?.unitable as TestVersion;
  }

  public addQuestion() {
    const questions_count = this.unitable().question_versions.length;

    this.unitable().question_versions.push(
      new TestQuestionVersion({
        position: questions_count + 1
      })
    );
  }

  public removeQuestion(qv_index: number) {
    this.unitable().question_versions.splice(qv_index, 1);

    this.unitable().question_versions.forEach(
      (qv, index) => (qv.position = index + 1)
    );
  }

  public changeQuestionType(question_version: TestQuestionVersion) {
    question_version.answer_versions.forEach(
      av => (av.answer.is_correct = false)
    );
  }

  public addAnswer(event: KeyboardEvent, qv_index: number) {
    const question_version = this.unitable().question_versions[qv_index];

    if (
      event.target &&
      event.target instanceof HTMLInputElement &&
      event.target.value.length
    ) {
      const answers_count = question_version.answer_versions.length;

      question_version.answer_versions.push(
        new TestAnswerVersion({
          value: event.target.value,
          position: answers_count + 1
        })
      );

      event.target.value = "";
    }
  }

  public removeAnswer(question_version: TestQuestionVersion, av_index: number) {
    question_version.answer_versions.splice(av_index, 1);

    question_version.answer_versions.forEach(
      (av, index) => (av.position = index + 1)
    );
  }

  public selectCorrectAnswer(
    question_version: TestQuestionVersion,
    av_index: number
  ) {
    if (question_version.isSingle) {
      question_version.answer_versions.forEach((answer_version, index) => {
        if (index !== av_index) {
          answer_version.answer.is_correct = false;
        }
      });
    }
  }
}
